import { LoadableAfterPaint } from '@confluence/loadable';

export const CreateWithRovoExperienceDismissText = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CreateWithRovoExperienceDismissText" */ '../src/CreateWithRovoExperienceDismissText.tsx'
			)
		).CreateWithRovoExperienceDismissText,
});
